/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/publishedReportModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:10 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 12 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import template from './views/sectionwise_attention.html';
import controller from './controllers/sectionwiseattentionController';
var module = angular.module('sectionWiseAttention', [
    //import modules
])
.controller('sectionWiseAttention', controller);

module.constant('sectionWiseAttention', {
})
// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('sectionWiseAttention', {
//             parent: 'app',
//             url: '/section-wise-attention',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'sectionWiseAttention'
//                 }
//             }
//         })

// });



// WEBPACK FOOTER //
// ./src/app/educore_reports/school/sectionwiseAttention.js